import React from "react";
import clsx from "clsx";

import styles from "./loader.module.scss";

const SpinnerLoader = ({ className = "", style = {} } = {}) => {
	return (
		<div
			data-autotest="spinner"
			className={clsx(styles.loadingSpinnerDualRing, className)}
			style={style}
		>
			<div className={styles.ldio}>
				<div></div>
				<div>
					<div></div>
				</div>
			</div>
		</div>
	);
};

export default SpinnerLoader;
